import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  bonusAdjustmentList: {
    list: {
      data: [],
      total: 0,
    },
  },
  bonusAdjustmentData: {},
}

export default {
  state,
  actions,
  mutations,
  getters,
}
